import { CampaignStatus } from '../';

export function isCampaignDeletable(status: CampaignStatus) {
  return status !== CampaignStatus.ACTIVE;
}
